import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-empty-detail-fact',
  templateUrl: './empty-detail-fact.component.html',
  styleUrls: ['./empty-detail-fact.component.css']
})
export class EmptyDetailFactComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
